<img [src]="src" class="carousel__image">
<img *ngIf="activated" [src]="srcActivated" class="carousel__image-activated">